import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          name: Yup.string()
                                                   .required('Required'),
                                          category: Yup.string().nullable(),
                                          description: Yup.string().nullable(),
                                      });
